<div class="sc-input" [class.sc-input--with-icon]="!!icon">
    <label
      *ngIf="label" [attr.for]="id ? id+'__input' : null"
      class="sc-input__label"
      [class.sc-input__label--floating]="!!value"
      [class.label--focus]="hasFocus"
      [class.sc-input__label--floating-has-error]="hasError"
    >{{ label }}</label>
    <div class="sc-input__input-group" >
        <span
          *ngIf="addOnPrefix"
          class="sc-input__input-group--prefix"
          [class.has-error]="hasError"
          [class.disabled-adon]="isDisabled"
          >{{addOnPrefix}}</span>

        <span
          *ngIf="addOnSubfix"
          class="sc-input__input-group--subfix"
          [class.has-error]="hasError"
          [class.disabled-adon]="isDisabled"
          >{{addOnSubfix}}</span>
      <input
            #elementRef
            [autocomplete]="autocomplete"
            [class.has-error]="hasError"
            class="sc-input__input-group__control"
            [disabled]="isDisabled"
            [attr.id]="id ? id+'__input' : null"
            [attr.inputmode]="inputmode"
            [placeholder]="(placeholder ? placeholder : '')"
            [readonly]="readonly"
            [type]="type"
            [value]="value"
            (blur)="onBlur($event)"
            (focus)="onFocus($event)"
            (input)="onInput($event)"
            [attr.maxLength]="maxlength"
             />




        <ng-container *ngIf="!!icon">
          <sc-icon class="sc-input__icon" [icon]="icon" *ngIf="!hasPasswordToggle && !iconClickHandler" [disabled]="isDisabled || readonly"></sc-icon>
          <sc-icon class="sc-input__icon" [icon]="icon" *ngIf="!hasPasswordToggle && iconClickHandler" [disabled]="isDisabled" (click)="iconClickHandler.subscribe()"></sc-icon>
          <sc-icon class="sc-input__icon" [icon]="icon"
           *ngIf="hasPasswordToggle"
           (mousedown)="showPassword()"
           (mouseup)="hidePassword()"
           (mouseleave)="hidePassword()"
           (press)="showPassword()"
           (pressup)="hidePassword()"
           [disabled]="isDisabled">
          </sc-icon>
        </ng-container>
    </div>
    <sc-form-control-error
      [errorMessages]="errorMessages"
      [control]="control"
      [hasError]="hasError"
      [hidden]="hideError"
      [debounceTime]="debounceTime">
    </sc-form-control-error>
</div>
